<template>
  <table class="table" id="unasigned-substudies">
    <thead>
      <tr>
        <th colspan="5">Not assigned</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="substudy in substudies">
        <td>{{ substudy.name }}</td>
        <td colspan="4">
          <button 
            class="btn btn-danger btn-xs" 
            @click="assignSubstudy(substudy)"
          >
            Assign {{ participant.full_name }} to {{ substudy.name }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
  import SubstudyResource from '../../resources/SubstudyResource.js';
    
  const props = defineProps(['substudies', 'participant'])

  function assignSubstudy(substudy) {
    SubstudyResource.participants.assignParticipant(substudy, props.participant)
        .then(function (response) {
            window.location.reload();
        })
    }
</script>